import React, {useState, useEffect, useCallback} from 'react'
import {Link} from 'react-router-dom'
import Pagination from "react-js-pagination"
import {useDispatch, useSelector} from 'react-redux'
import debounce from 'lodash/debounce'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faEye} from '@fortawesome/free-solid-svg-icons'

import {getPatients} from '../store/slices/hcpSlice'
import PatientFormModal from '../components/PatientFormModal'

function PatientList() {
    const dispatch = useDispatch()
    const {patients, patientsPagination, isLoading} = useSelector(state => state.hcp)
    const [length, setLength] = useState(10)
    const [searchQuery, setSearchQuery] = useState('')
    const [modalShow, setModalShow] = useState(false)
    const [editingPatient, setEditingPatient] = useState(null)
    const {current_page, per_page, total} = patientsPagination

    const index = (page = 1) => {
        dispatch(getPatients({page, per_page: length, search: searchQuery}))
    }
    const delayedQuery = useCallback(debounce(index, 500), [searchQuery, length])

    useEffect(() => {
        delayedQuery()
        return delayedQuery.cancel
    }, [searchQuery, length, delayedQuery])

    const openEdit = (p) => {
        setEditingPatient(p)
        setModalShow(true)
    }

    const handleSaved = () => {
        index(current_page || 1)
    }

    return (
        <div className="content-wrapper">
            <section className="content pt-3">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="float-left">
                                        <h2 className="card-title pt-1">Patients</h2>
                                        {isLoading && <span className="ml-3"><div className="loader"/></span>}
                                    </div>
                                    <div className="float-right">
                                        <input value={searchQuery}
                                               onChange={e => setSearchQuery(e.target.value)}
                                               className="form-control form-control-sm" type="text"
                                               placeholder="Search by name"/>
                                    </div>
                                </div>
                                <div className="card-body" style={{overflowX: 'auto'}}>
                                    <table className="table table-hover table-sm">
                                        <thead>
                                        <tr>
                                            <th>NAME</th>
                                            <th>RELATIONSHIP</th>
                                            <th>DOB</th>
                                            <th>SEX</th>
                                            <th>PHONE</th>
                                            <th>INSURANCE</th>
                                            <th>ACCOUNT</th>
                                            <th className="text-center">ACTIONS</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {patients && patients.length === 0 && (
                                            <tr><td colSpan="8" className="text-center text-muted">
                                                No patients found.
                                            </td></tr>
                                        )}
                                        {patients && patients.map((p, i) => (
                                            <tr key={p._id || i}>
                                                <td>{p.first} {p.last}</td>
                                                <td>{p.relationship}{p.isSelf ? ' (self)' : ''}</td>
                                                <td>{p.dateOfBirth ? new Date(p.dateOfBirth).toLocaleDateString() : '—'}</td>
                                                <td>{p.sex || '—'}</td>
                                                <td>{p.mobile || '—'}</td>
                                                <td>{p.insurance || '—'}</td>
                                                <td>
                                                    {p.account ? (
                                                        <Link to={`/user/${p.account._id || p.account}`}>
                                                            {p.account.email || 'View'}
                                                        </Link>
                                                    ) : '—'}
                                                </td>
                                                <td className="text-center">
                                                    <div className="btn-group btn-group-sm">
                                                        {p.account && (
                                                            <Link to={`/user/${p.account._id || p.account}`}
                                                                  className="btn btn-sm" title="View account">
                                                                <FontAwesomeIcon icon={faEye} className='text-primary'/>
                                                            </Link>
                                                        )}
                                                        <button type="button" className="btn btn-sm"
                                                                onClick={() => openEdit(p)}>
                                                            <FontAwesomeIcon icon={faEdit} className='text-green'/>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>

                                    <PatientFormModal
                                        show={modalShow}
                                        onHide={() => setModalShow(false)}
                                        onSaved={handleSaved}
                                        initialPatient={editingPatient}
                                    />
                                </div>
                                <div className="card-footer">
                                    <div className="float-left">
                                        {total > 0 && (
                                            <>
                                                <select value={length} onChange={e => setLength(+e.target.value)}>
                                                    <option value={10}>10 entries</option>
                                                    <option value={20}>20 entries</option>
                                                    <option value={50}>50 entries</option>
                                                    <option value={100}>100 entries</option>
                                                </select> &nbsp;
                                                Showing {((current_page - 1) * per_page) + 1} to {total > current_page * per_page ? current_page * per_page : total} of {total} entries
                                            </>
                                        )}
                                    </div>
                                    <div className="float-right">
                                        <Pagination
                                            activePage={parseInt(current_page) || 1}
                                            itemsCountPerPage={parseInt(per_page) || length}
                                            totalItemsCount={parseInt(total) || 0}
                                            onChange={(page) => index(page)}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default PatientList
